import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import GroupsIcon from '@mui/icons-material/Groups';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { useNavigate } from 'react-router-dom';

function Contribute() {
  const navigate = useNavigate();
  
  return (
    <Box 
      sx={{ 
        backgroundColor: '#f2f7fa', 
        padding: 1, 
        marginTop: 3, 
        alignItems: 'center', 
        display: 'flex', 
        flexDirection: 'column' 
      }}
    >
      <Typography
        variant="h5"
        fontWeight={600}
        textAlign="center"
        mb={1}
      >
        Contribute
      </Typography>
      
      <Box
        sx={{ 
          display: 'flex', 
          flexDirection: {xs: 'column', md: 'row'}, 
          gap: 2,
          width: '100%',
          maxWidth: 'lg'
        }}
      >
        {/* Become an Author */}
        {/* <Box
          sx={{
            background: 'linear-gradient(135deg, #004d40, #00796b)',
            color: '#fff',
            p: 4,
            borderRadius: 1,
            width: {md: '33.33%'},
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            textAlign: 'center',
          }}
        >
          <EditNoteIcon sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Publish Article
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Share your research by publishing your articles on our platform.
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: '#fff',
              color: '#004d40',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#e0f2f1',
              },
            }}
            onClick={() => navigate('/publish-article')}
          >
            Submit Manuscript
          </Button>
        </Box> */}

        {/* Join Editorial Board */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #7b1fa2, #9c27b0)',
            color: '#fff',
            p: 4,
            borderRadius: 1,
            width: {md: '50%'},
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            textAlign: 'center',
          }}
        >
          <SupervisorAccountIcon sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Join Editorial Board
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Help shape our publication by joining our editorial board and guiding content direction.
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: '#fff',
              color: '#7b1fa2',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#f3e5f5',
              },
            }}
            onClick={() => navigate('/join-editorial-board')}
          >
            Apply Now
          </Button>
        </Box>
        
        {/* Join as Peer Reviewer */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #0d47a1, #1976d2)',
            color: '#fff',
            p: 4,
            borderRadius: 1,
            width: {md: '50%'},
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            textAlign: 'center',
          }}
        >
          <GroupsIcon sx={{ fontSize: 40, mb: 1 }} />
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Join Peer Review
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Help maintain research quality by reviewing and evaluating submitted papers.
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: '#fff',
              color: '#0d47a1',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#e3f2fd',
              },
            }}
            onClick={() => navigate('/join-peer-review')}
          >
            Join Now
          </Button>
        </Box>
        
      </Box>
    </Box>
  );
}

export default Contribute;